import { AxiosProgressEvent } from "axios";

import { fetcher } from "helpers/fetcher";

import { TFileUploadReq, TFileUploadRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addEmployeeDriverLicence = async (
  payload: TFileUploadReq,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
) => {
  return await fetcher<TFileUploadRes, TFileUploadReq["data"]>(
    ENDPOINT.USER.ADD_EMPLOYEE_DRIVER_LICENCE,
    {
      data: payload.data,
      fileFields: ["file"],
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.ADD_EMPLOYEE_DRIVER_LICENCE.version,
        [API_HEADER.USER_ID]: payload.idUser,
      },
      onUploadProgress: (progressEvent) => {
        if (onUploadProgress) onUploadProgress(progressEvent);
      },
    }
  );
};
